import parent from './wgg.module';

/**
 * @ngdoc object
 * @name wgg.configure
 *
 * @requires $locationProvider
 * @requires $urlRouterProvider
 * @requires $stateProvider
 *
 * @description
 * Config phase of the wgg module.
 */

parent.config(
    function configure() {

});




// WEBPACK FOOTER //
// ./src/wgg/wgg.config.js